import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';
import { ApplicationRef } from '@angular/core';
bootstrapApplication(AppComponent, APP_CONFIG)
  .then((module) => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
  .catch((err) => console.error(err));
